import React from "react";
import { AppIcon } from "@toothfairy/shared-ui";
const TreeIcon = ({ size, isAgentIcon, ...props }) => {
  const iconSize = size || (isAgentIcon ? 14 : 14);
  const isFolderIcon = props?.icon?.iconName === "folder";

  return (
    <AppIcon
      wrapperStyle={{
        marginBottom: isFolderIcon ? 0 : 2,
      }}
      isClickable
      size={iconSize}
      {...props}
    />
  );
};

export default TreeIcon;
